import { CommandCenterHeader } from "@components";
import { Role } from "@enums";
import { Stack } from "@mui/material";
import { useCheckUserRole } from "@utils/useCheckUserRole";
import { useNavigate, useParams } from "react-router-dom";
import { JobsOverviewCard } from "./components/JobsOverviewCard";
import { ServerStatusCard } from "./components/ServerStatusCard";
import { useEffect } from "react";

const ConsumerDetailPage = () => {
  const { tenantId: tenantIdString } = useParams();
  const tenantId = tenantIdString ? Number(tenantIdString) : undefined;
  const navigate = useNavigate();
  // Check if user has automation deployment role
  const hasDeploymentAccess = useCheckUserRole(Role.AUTOMATION_DEPLOYMENT);

  // If user doesn't have deployment role, show error page
  useEffect(() => {
    if (!hasDeploymentAccess) {
      navigate("/error");
    }
  }, [hasDeploymentAccess, navigate]);

  return (
    <Stack
      sx={{
        height: 1,
        width: 1,
        maxWidth: 1700,
        maxHeight: 1,
        padding: 2,
        gap: 1,
      }}
    >
      <CommandCenterHeader title="Consumers" />
      <Stack
        sx={{
          gap: 2,
        }}
      >
        {tenantId && (
          <>
            <ServerStatusCard tenantId={tenantId} />
            <JobsOverviewCard tenantId={tenantId} />
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default ConsumerDetailPage;
